// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tNiu9","title":"styles_title__qzLmu"};